// src/components/Footer.js
import React from 'react';


const Footer = () => {
  return (
    <footer className="footer-container" style={{ padding: '20px', backgroundColor: '#98CDB1', textAlign: 'center', fontFamily: '"Kaisei HarunoUmi", serif'}}>
      <p>© 2025 Northside Dental Partners. All rights reserved.</p>
      <p>
        <a 
          href="https://maps.app.goo.gl/MUTdzHJyVDB4DRcx5" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{ color: 'inherit', textDecoration: 'none' }}
        >
           Address:  8329 Roswell Road NE, Sandy Springs, GA 30350
        </a>
      </p>
      <p>Email: <a href="mailto:northsidedental@bellsouth.net">northsidedental@bellsouth.net</a></p>
      <p>Phone: <a href="tel:7706711111">(770)-671-1111</a></p>
      <p>Fax: (770)-379-0992</p>
    </footer>

  );
};

export default Footer;
